import { Tabs } from "@chakra-ui/react";
import * as React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import Page from "../../components/page";
import PageBody from "../../components/page-body";
import PageHeader from "../../components/page-header";
import { useWorkspaceURL } from "../../hooks";

export default function SettingsRoot() {
  const workspaceURL = useWorkspaceURL();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Page>
      <PageBody>
        <PageHeader
          title="Settings"
          subtitle="Manage your workspace settings"
        />
        <Tabs.Root
          colorPalette="gray"
          fitted
          maxW="xl"
          onValueChange={(e) => navigate(e.value)}
          value={location.pathname}
          variant="enclosed"
        >
          <Tabs.List>
            <Tabs.Trigger value={workspaceURL("settings")}>
              General
            </Tabs.Trigger>
            <Tabs.Trigger value={workspaceURL("settings/integrations")}>
              Integrations
            </Tabs.Trigger>
            <Tabs.Trigger value={workspaceURL("settings/pixel")}>
              Pixel
            </Tabs.Trigger>
          </Tabs.List>
        </Tabs.Root>
        <Outlet />
      </PageBody>
    </Page>
  );
}
